var map = {
	"./N1.png": 99387,
	"./N2.png": 37408,
	"./N3.png": 92233,
	"./N4.png": 92406,
	"./N5.png": 88735,
	"./N6.png": 34084,
	"./N7.png": 74029,
	"./S1.png": 36808,
	"./S2.png": 73667,
	"./S3.png": 25914,
	"./ohne.png": 42114
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51807;